import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dropdown acct"
}
const _hoisted_2 = ["data-bs-toggle", "aria-label"]
const _hoisted_3 = { class: "acct-avatars" }
const _hoisted_4 = ["title"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "acct-av acct-av-active" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "acct-text" }
const _hoisted_11 = { class: "acct-label" }
const _hoisted_12 = { class: "acct-name" }
const _hoisted_13 = {
  key: 0,
  class: "ph ph-caret-up-down acct-caret",
  "aria-hidden": "true"
}
const _hoisted_14 = {
  key: 0,
  class: "dropdown-menu acct-menu"
}
const _hoisted_15 = { class: "acct-menu-title" }
const _hoisted_16 = ["disabled", "onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "acct-item-text" }
const _hoisted_20 = { class: "acct-item-name" }
const _hoisted_21 = { class: "acct-item-tag" }
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm acct-item-end"
}
const _hoisted_23 = {
  key: 1,
  class: "ph ph-check acct-item-end acct-check",
  "aria-hidden": "true"
}
const _hoisted_24 = { class: "acct-menu-foot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["acct-pill", { 'is-sub': _ctx.isSubContext, 'is-static': !_ctx.canSwitch }]),
          "data-bs-toggle": _ctx.canSwitch ? 'dropdown' : null,
          "aria-expanded": "false",
          "aria-label": _ctx.$t('account.activeAccount', { name: _ctx.activeName }) + (_ctx.canSwitch ? _ctx.$t('account.switchHint') : '')
        }, [
          _createElementVNode("span", _hoisted_3, [
            (_ctx.isSubContext)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "acct-av acct-av-parent",
                  title: _ctx.brandName
                }, [
                  (_ctx.brand?.logo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.brand.logo,
                        alt: ""
                      }, null, 8, _hoisted_5))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.initial(_ctx.brand)), 1))
                ], 8, _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_7, [
              (_ctx.active?.logo)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.active.logo,
                    alt: ""
                  }, null, 8, _hoisted_8))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.initial(_ctx.active)), 1))
            ])
          ]),
          _createElementVNode("span", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.isSubContext ? _ctx.$t("account.subAccountOf", { name: _ctx.brandName }) : _ctx.$t("account.mainAccount")), 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.activeName), 1)
          ]),
          (_ctx.canSwitch)
            ? (_openBlock(), _createElementBlock("i", _hoisted_13))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2),
        (_ctx.canSwitch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("account.switchAccount")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.auth.accounts, (account) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: account.id,
                  type: "button",
                  class: _normalizeClass(["acct-item", { current: _ctx.isCurrent(account) }]),
                  disabled: _ctx.entering !== null || _ctx.isCurrent(account) || (!_ctx.isRoot(account) && !account.active),
                  onClick: ($event: any) => (_ctx.enter(account))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["acct-av acct-av-sm", { root: _ctx.isRoot(account) }])
                  }, [
                    (account.logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: account.logo,
                          alt: ""
                        }, null, 8, _hoisted_17))
                      : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.initial(account)), 1))
                  ], 2),
                  _createElementVNode("span", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(account.name || account.store), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.isRoot(account) ? _ctx.$t("account.mainAccount") : account.active ? _ctx.$t("account.subAccount") : _ctx.$t("account.inactive")), 1)
                  ]),
                  (_ctx.entering === account.id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                    : (_ctx.isCurrent(account))
                      ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                      : _createCommentVNode("", true)
                ], 10, _hoisted_16))
              }), 128)),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_router_link, {
                  to: "/choose-account",
                  class: "dropdown-item"
                }, {
                  default: _withCtx(() => [
                    _cache[0] || (_cache[0] = _createElementVNode("i", {
                      class: "ph ph-squares-four",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("account.allAccounts")), 1)
                  ]),
                  _: 1,
                  __: [0]
                }),
                (!_ctx.auth.isInSubAccount)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/sub-accounts",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _cache[1] || (_cache[1] = _createElementVNode("i", {
                          class: "ph ph-gear-six",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("account.manageSubAccounts")), 1)
                      ]),
                      _: 1,
                      __: [1]
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}